import {Observable} from 'rxjs';
import {
  CreateProductPayloadDto
} from '@features/product/application/use_cases/create-product/dto/create-product.payload.dto';
import {
  CreateProductResponseDto
} from '@features/product/application/use_cases/create-product/dto/create-product.response.dto';
import {
  DeleteProductPayloadDto
} from '@features/product/application/use_cases/delete-product/dto/delete-product.payload.dto';
import {
  DeleteProductResponseDto
} from '@features/product/application/use_cases/delete-product/dto/delete-product.response.dto';
import {
  FindOneProductPayloadDto
} from '@features/product/application/use_cases/find-one-product/dto/find-one-product.payload.dto';
import {
  FindOneProductResponseDto
} from '@features/product/application/use_cases/find-one-product/dto/find-one-product.response.dto';
import {
  HiddenProductPayloadDto
} from '@features/product/application/use_cases/hidden-product/dto/hidden-product.payload.dto';
import {
  HiddenProductResponseDto
} from '@features/product/application/use_cases/hidden-product/dto/hidden-product.response.dto';
import {ListProductPayloadDto} from '@features/product/application/use_cases/list-product/dto/list-product.payload.dto';
import {
  ListProductResponseDto
} from '@features/product/application/use_cases/list-product/dto/list-product.response.dto';
import {
  SetDefaultProductPayloadDto
} from '@features/product/application/use_cases/set-default-product/dto/set-default-product.payload.dto';
import {
  SetDefaultProductResponseDto
} from '@features/product/application/use_cases/set-default-product/dto/set-default-product.response.dto';
import {ShowProductPayloadDto} from '@features/product/application/use_cases/show-product/dto/show-product.payload.dto';
import {
  ShowProductResponseDto
} from '@features/product/application/use_cases/show-product/dto/show-product.response.dto';
import {
  UpdateProductPayloadDto
} from '@features/product/application/use_cases/update-product/dto/update-product.payload.dto';
import {
  UpdateProductResponseDto
} from '@features/product/application/use_cases/update-product/dto/update-product.response.dto';
import {
  FindByIdProductPayloadDto
} from '@features/product/application/use_cases/find-by-id-product/dto/find-by-id-product.payload.dto';
import {
  FindByIdProductResponseDto
} from '@features/product/application/use_cases/find-by-id-product/dto/find-by-id-product.response.dto';

export const PRODUCT_PORT = Symbol("PRODUCT_PORT");

export abstract class ProductPort {
  abstract createProduct(payload: CreateProductPayloadDto): Observable<CreateProductResponseDto>;

  abstract deleteProduct(payload: DeleteProductPayloadDto): Observable<DeleteProductResponseDto>;

  abstract findOneProduct(payload: FindOneProductPayloadDto): Observable<FindOneProductResponseDto>;

  abstract findByIdProduct(payload: FindByIdProductPayloadDto): Observable<FindByIdProductResponseDto | null>;

  abstract hiddenProduct(payload: HiddenProductPayloadDto): Observable<HiddenProductResponseDto>;

  abstract listProduct(payload: ListProductPayloadDto): Observable<ListProductResponseDto>;

  abstract setDefaultProduct(payload: SetDefaultProductPayloadDto): Observable<SetDefaultProductResponseDto>;

  abstract showProduct(payload: ShowProductPayloadDto): Observable<ShowProductResponseDto>;

  abstract updateProduct(payload: UpdateProductPayloadDto): Observable<UpdateProductResponseDto>;
}
